module.exports = __webpack_public_path__ + "static/media/bg-4.71f90a94.svg";